import React from 'react';
import {FooterModuleDesktopTopLogoDescription} from "./footer-module.desktop.top.logo-description";
import {FooterModuleDesktopTopButtons} from "./footer-module.desktop.top.buttons";
import styles from "../../styles/footer.module.scss";
import classNames from "classnames";

export const FooterModuleDesktopTop = ({controller}) => {
  return (
    <div className={classNames(styles.top_content)}>
      <FooterModuleDesktopTopLogoDescription controller={controller}/>
      <FooterModuleDesktopTopButtons controller={controller}/>
    </div>
  );
}
